import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { gerarPdfManualQualidade, nomePdfManualQualidade } from "./gerarPdfManualQualidade";

export default function RelatorioManualQualidade({ registro, onVoltar }) {
  const [arquivo, setArquivo] = useState(null);

  useEffect(() => {
    if (!registro) {
      setArquivo(null);
      return undefined;
    }
    let ativo = true;
    let url = "";

    setArquivo(null);
    gerarPdfManualQualidade(registro).then((pdf) => {
      if (!ativo) return;
      const blob = pdf.output("blob");
      url = URL.createObjectURL(blob);
      setArquivo({ nome: nomePdfManualQualidade(registro), url });
    });

    return () => {
      ativo = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [registro]);

  async function baixarPdf() {
    const pdf = await gerarPdfManualQualidade(registro);
    pdf.save(nomePdfManualQualidade(registro));
  }

  if (!arquivo) return <Box sx={{ p: 4, textAlign: "center" }}><CircularProgress /></Box>;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#e8edf2", p: 2 }}>
      <Stack direction="row" spacing={1} justifyContent="center" mb={2}>
        <Button variant="outlined" onClick={onVoltar}>Voltar</Button>
        <Button onClick={baixarPdf} variant="contained">Baixar PDF</Button>
      </Stack>
      <Box component="iframe" title="Relatório do Manual da Qualidade" src={arquivo.url} sx={{ display: "block", width: "100%", height: "calc(100vh - 86px)", border: 0, bgcolor: "white" }} />
    </Box>
  );
}
